import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import AsyncModalRequestConfirmation from "../shared/AsyncModalRequestConfirmation";

export const CAMPAIGN_FORMAT_OPTIONS = [
  { value: "page", text: "Landing Page" },
  { value: "overlay", text: "Overlay Popup" },
  { value: "hook", text: "Hook Popup" },
  { value: "bar", text: "Sticky Bar" },
  { value: "inline", text: "Embed" },
];

const defaultCampaignName = (cta) => {
  if (cta?.name) return `${cta.name} (copy)`;
  return "";
};

const DuplicateToNewCampaignModal = ({
  isOpen,
  onClose,
  cta,
  variant,
  endpoint,
  onSuccess,
}) => {
  const [campaignName, setCampaignName] = useState(defaultCampaignName(cta));
  const [ctaType, setCtaType] = useState(cta?.cta_type || "page");

  useEffect(() => {
    if (!isOpen) return;

    setCampaignName(defaultCampaignName(cta));
    setCtaType(cta?.cta_type || "page");
  }, [isOpen, cta]);

  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="duplicateToNewCampaignLabel"
      style={{
        display: "block",
        background: "rgba(0, 0, 0, 0.5)",
        zIndex: 1040,
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="modal-dialog"
        role="document"
        style={{ maxWidth: "480px", marginTop: "12vh" }}
      >
        <div className="modal-content smooth !rounded-lg">
          <form>
            <div className="modal-header !border-slate-200">
              <button
                type="button"
                className="close"
                onClick={onClose}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    d="M12.2996 4.1001L4.09961 12.3001M12.2996 12.3001L4.09961 4.1001"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
              <h4
                id="duplicateToNewCampaignLabel"
                className="modal-title smooth bold"
              >
                Copy to new campaign
              </h4>
            </div>

            <div className="modal-body" style={{ padding: "24px" }}>
              <p className="text-slate-500 text-xl" style={{ marginTop: 0 }}>
                Name the new campaign and choose its format.
              </p>

              <input type="hidden" name="id" value={variant?.id || ""} />

              <div className="mb-4">
                <label
                  className="setting-label text-xl text-black capitalize"
                  htmlFor="duplicate-to-new-campaign-name"
                >
                  Name
                </label>
                <input
                  id="duplicate-to-new-campaign-name"
                  type="text"
                  name="campaign_name"
                  className="form-control text-field input-lg"
                  placeholder="Campaign name"
                  value={campaignName}
                  onChange={(event) => setCampaignName(event.target.value)}
                />
              </div>

              <div>
                <label
                  className="setting-label text-xl text-black capitalize"
                  htmlFor="duplicate-to-new-campaign-format"
                >
                  Campaign Format
                </label>
                <select
                  id="duplicate-to-new-campaign-format"
                  name="cta_type"
                  className="form-control text-field input-lg"
                  value={ctaType}
                  onChange={(event) => setCtaType(event.target.value)}
                >
                  {CAMPAIGN_FORMAT_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.text}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="modal-footer !border-slate-200 flex justify-end">
              <AsyncModalRequestConfirmation
                endpoint={endpoint}
                loadingMessage="Duplicating..."
                readyCallback={onSuccess}
              >
                <button type="submit" className="btn blue-button smooth">
                  Duplicate
                </button>
              </AsyncModalRequestConfirmation>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DuplicateToNewCampaignModal;
